import React, {createRef, useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {useQueryClient} from "react-query";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import parse from "html-react-parser";

import "../../App.css";
import SystemContext from "../../SystemContext";
import {getDefaultValuesWithoutAlert} from "../../functions/TemplateHelperFunctions";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import Dialog from "../../controls/Dialog";
import EnquiriesStyles from "./styles/EnquiriesStyles";
import {Loading} from "../../controls";
import {useCompanies} from "../../services/companies";
import AddEnquiryDialog from "./components/AddEnquiryDialog";
import __ from "lodash";
import { useAddEnquiry } from "../../services/enquiry";
import { useComboValues } from "../../services/settings";

const AccessControl = require ("../../AccessControl");


function NewEnquiry(props) {
  const SystemData = useContext(SystemContext);
  const classes = makeStyles(EnquiriesStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage BOOKINGS", "Client ADMIN", "Client ACCESS"]);
  const userInfo = AccessControl.getUserInfo();
  const userClass = userInfo?.userClass;
  const [defaults, setDefaults] = useState(null);

  const queryClient = useQueryClient();
  const companyData = useCompanies({queryClient, extraKeys: [userInfo?.companyUuid]});
  const activityStatuses = useComboValues({queryClient, extraKeys: ["ENQUIRIES", "ACTIVITY STATUS"]});

  const history = useHistory();
  const handleClose = event => {
    SystemData.goHome(history);
  };

  const handleAddEnquiry = useAddEnquiry();

  const dialogMessage = (<div style={{maxWidth: 1100}}><p>To request a quote please fill out the form below and a member of our team will be in touch shortly.</p><p>We will use the information that you provide in this web form to respond to your enquiry using the contact details you have provided. This information may be shared with members of staff across our corporate group in order to do so. Please also refer to our Privacy Notice.</p></div>)
  const title = "Request a Quote";

  const newStatus = __.find(activityStatuses.data, {code: "NEW"});
  let nextActionDate = moment.utc().add(8, "hours").toISOString();
  let nextActivity = 'REVIEW';
  if (newStatus && newStatus.data && newStatus.data.nextActivity && newStatus.data.nextActivityInterval && newStatus.data.nextActivityIntervalUnits) {
    nextActionDate = moment.utc().add(newStatus.data.nextActivityInterval, newStatus.data.nextActivityIntervalUnits).toISOString();
    nextActivity = newStatus.data.nextActivity;
  }

  const record = {
    enquirySource: userClass ==="GSA" ? "EXTERNAL" : "INTERNAL",
    enquiryDate: moment.utc().toISOString(),
    enquiryInfo: null,
    companyName: null,
    companyUuid: null,
    contactName: null,
    contactEmail: null,
    contactPhone: null,
    originAirportCode: null,
    destinationAirportCode: null,
    payload: null,
    payloadUom: "TONNE",
    cargoAvailability: null,
    requiredAtDestination: null,
    orderFirmness: 0,
    accountManagerId: null,
    status: "NEW",
    nextActionDate,
    nextActivity,
    respondBy: nextActionDate,
  }

  const getDefaults = async () => {
    const defaults = await getDefaultValuesWithoutAlert(SystemData, "booking", "defaults");
    if (!defaults)
      return null;
    return defaults;
  }

  getDefaults()
    .then((bookingDefaults) => {
      if (!defaults)
        setDefaults(bookingDefaults);

    })
    .catch((error) => {
      handleClose();
      SystemData.alert("Error", error);
    });

  if (userClass ==="GSA" && companyData && companyData.data && Array.isArray(companyData.data) && companyData.data.length > 0) {
    const company = companyData.data[0];
    record["companyUuid"] = userInfo.companyUuid;
    record["companyName"] = company.companyName;

    if (userInfo && __.has(userInfo, ["firstName"]) && __.has(userInfo, ["lastName"])) {
      record["contactSalutation"] = userInfo.title;
      record["contactFirstName"] = userInfo.firstName;
      record["contactLastName"] = userInfo.lastName;
      record["contactEmail"] = userInfo.email;
      record["companyContact"] = `${userInfo.title ? userInfo.title + " " : ""} ${userInfo.firstName ?? ""} ${userInfo.lastName ?? ""} ${userInfo.email?`(${userInfo.email})`:``}`;
    }
  }

  return (isAuthenticated &&
    <div
      className="NewEnquiry"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="newenquiry"
        pageName="New Enquiry"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 40, marginRight: 40, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, backgroundColor: "#f1f1f1"}}
      >
         {/*formMode:*/}
         {/*=========*/}
         {/*GSA - for GSA bookings (does not require GSA selection),*/}
         {/*OPERATOR - for system operator bookings (requires GSA selection),*/}
         {/*SLR - for special load requests.*/}
         {/*userClass will return "OPERATOR" for Magma users and companyUuid for external users*/}

        <div style={{display: "flex"}}>
          {defaults && companyData
            ?
              <AddEnquiryDialog
                systemData={SystemData}
                defaults={defaults}
                record={record}
                canEdit={canEdit}
                newEnquiry={true}
                formMode={userClass||"WEB"}
                close={handleClose}
                classes={classes}
                dialogStates={{showDialog: true, title, dialogMessage, record}}
                showFullPage={false}
                fullPageStyle={{backgroundColor: "#e1e1e1"}}
                handleAdd={handleAddEnquiry}
              />
            :
              defaults ?
                <Dialog
                  message="Loading Data"
                  open={true}
                  buttons={{}}
                >
                  <Loading/>
                </Dialog>
                : <></>
          }

        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default NewEnquiry;
